import { useState, useLayoutEffect } from 'react';
import _ from 'lodash';

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

export function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions(),
  );

  useLayoutEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    function handleViewportResize() {
      if (window.visualViewport) {
        for (const sessionView of document.getElementsByClassName(
          'SessionView',
        )) {
          (sessionView as any).style.height =
            window.visualViewport.height.toString() + 'px';
          document.getElementsByTagName('html')[0].style.height =
            window.visualViewport.height.toString() + 'px';
          setWindowDimensions({
            width: window.visualViewport.width,
            height: window.visualViewport.height,
          });
        }
      }
    }

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', handleViewportResize);
    } else {
      window.addEventListener('resize', handleResize);
    }
    return () => {
      if (window.visualViewport) {
        window.visualViewport.removeEventListener(
          'resize',
          handleViewportResize,
        );
      } else {
        window.removeEventListener('resize', handleResize);
      }
    };
  }, []);

  return windowDimensions;
}

export const humanize = (str: string) => {
  return _.capitalize(
    _.trim(_.snakeCase(str).replace(/_id$/, '').replace(/_/g, ' ')),
  );
};
